import React from 'react';

const Map = () => {
    return (
        <div className="container my-5">
            <div className="text-center my-3">
                <h2>Our Location</h2>
                <hr className="mb-4 mt-0 d-inline-block mx-auto" style={{"width": "150px", "height": "4px"}} ></hr>
            </div>
            
            {/* google map */}
            <section>
                <div class="container my-5">

                    <iframe className="w-100" title="kaptai" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7371.82459376676!2d92.2112523!3d22.5074735!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30ad4958523d0429%3A0x79f8d423efadd124!2sSwedish%20Hostel!5e0!3m2!1sen!2sbd!4v1635699730039!5m2!1sen!2sbd" height="450px" style={{"border":"0"}} allowfullscreen="" loading="lazy"></iframe>

                </div>
            </section>
        </div>
    );
};

export default Map;